import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    ORFButton as Button
    , OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
} from '../../../../../../common/forms/order-request-form.component';
import { newQuotationActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-quotation.reducer";
import { requestLogActions } from "./../../../../../../../store/external/request-reducer/request-log.reducer";
import { NotificationModal } from '../../../../../../common/modal/notification-modal.component';
import { ConfirmationNotificationModal } from '../../../../../../common/modal/confirmation-modal.component';
import { MAX_LENGTH, SUBMIT_REQUEST, SUBMIT_REQUEST_TITLE, PURPOSEOFUSEOPTIONS } from '../../../../../../../constants/external-constants';

class QuotationBusinessForm extends Component {
    constructor(props) {
        super(props);
        this.state={
            showConModal:false
        }
    }

    submitRequest = () => {
        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
        const { submitRequest, fetchRequestLogItems } = this.props;
        if (buttonType === CONFIRMATION_VALUE.Ok) {
             
              this.setState( prev => ({
                isSaving:true,
             }))

            var success = await submitRequest();
            if (success.Success) {                           
                this.setState({
                    title:"Success"
                })
                this.props.hideRequestModal(); 
                fetchRequestLogItems(0);
            }else {
                this.setState({
                    title:"Error"
                })
            }
            this.setState( prev => ({
                showConModal: !prev.showConModal,
                show:true, 
                isSaving:false,                   
                message:success.Message
            }))
        }else{
            this.setState({
                showConModal: false
            });
        }
    }

    handleCloseNotif = () => {
        this.setState({ show: false, isSaving:false });
        if(this.state.title!=="Error")
        {            
            this.props.history.goBack();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    toReduceOptions = (obj) => {
        return obj?.filter(obj => obj.Value !== PURPOSEOFUSEOPTIONS.specialUseSub && obj.Value !== PURPOSEOFUSEOPTIONS.workSub)
    }

    render() {
        const {
            //component props
            onClickCancel
            , prevAction
            // form
            , quotationBusinessFormA
            // reducer action
        } = this.props;

        const { purposeOfUseOptions, formSubmitted } = this.props.quotationRequest;
        return (
            <div>
                <Form method="post" role="form"
                    model="quotationBusinessFormA"
                    onSubmit={this.submitRequest}
                >
                    <div >
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required'>
                                <Select
                                    className="form-control country-label"
                                    label={`${this.toLocaleLanguage('purpose_of_use')}`} 
                                    options={this.toReduceOptions(purposeOfUseOptions)}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.purposeOfUseId'
                                    value={quotationBusinessFormA.purposeOfUseId}                                   
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required'>
                                <TextArea
                                    label={`${this.toLocaleLanguage('business_justification')}`}
                                    fieldProp='.businessJustification'
                                    value={quotationBusinessFormA.businessJustification}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.limit_500}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={this.toLocaleLanguage('additional_information')}
                                    fieldProp='.additionalInformation'
                                    value={quotationBusinessFormA.additionalInformation}                  
                                    maxLength={MAX_LENGTH.limit_1000}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                />
                            </Col>
                        </Row>
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <Button
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    type="button"
                                    action={onClickCancel}
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('back')}
                                        variant={"outline-secondary"}
                                        type="button"
                                        action={prevAction}
                                    />
                                </div>
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('submit_request_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={
                                            quotationBusinessFormA.purposeOfUseId == 0
                                            || quotationBusinessFormA.businessJustification == ''
                                            || formSubmitted
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>

                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />

                 <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={SUBMIT_REQUEST.submitRequest}
                    title={SUBMIT_REQUEST_TITLE.submitRequest}
                    handleModal={this.handleConfirmationModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

            </div>
        );
    }
};
export default withRouter(connect(
    state => {
        const { quotationRequest, translation } = state;
        const { quotationBusinessFormA } = state.form;
        return {
            quotationRequest
            , quotationBusinessFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newQuotationActions
                , requestLogActions),
            dispatch
        )
)(QuotationBusinessForm));
